import { render, staticRenderFns } from "./Attributes.vue?vue&type=template&id=489ddf0a&scoped=true"
import script from "@/views/Settings/Attributes/Attributes.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/Attributes/Attributes.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/Attributes/attributes.scss?vue&type=style&index=0&id=489ddf0a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489ddf0a",
  null
  
)

export default component.exports